import ProjectSocketModel from 'models/sockets/project-socket-model';
import { handleActions } from 'redux-actions';
import {
  initProjectSocketIOSocketClient,
  setProjectSocketClient,
  clearProjectSocketClientInStore,
  stopProjectSocketConnection,
} from 'store/actions/project-socket-actions';
import { setProjectSocketDisconnectAction } from 'store/actions/action-creators';

export default handleActions(
  {
    [initProjectSocketIOSocketClient]: (projectSocket, { payload }) => {
      const { projectId, geoCode, dispatch, currentUser } = payload;
      return projectSocket.init({ projectId, geoCode, dispatch, currentUser });
    },
    [setProjectSocketClient]: (projectSocket, { payload }) => {
      return projectSocket.setProjectSocketClients(payload);
    },
    [setProjectSocketDisconnectAction]: (projectSocket, { payload }) => {
      return projectSocket.setProjectSocketDisconnect(payload);
    },
    [stopProjectSocketConnection]: (projectSocket) => {
      return projectSocket.stopProjectSocketConnection();
    },
    [clearProjectSocketClientInStore]: () => {
      return new ProjectSocketModel();
    },
  },
  new ProjectSocketModel(),
);
